export default __webpack_public_path__ + "static/media/ray13.0ee7de86.webp";